import {useSessionStore} from '@/stores'
import {jsonRpc} from '@communication'
import {onMounted, onUnmounted} from 'vue'

export const useBackendNotificationCallback = () => {
  const session = useSessionStore()

  const onNotification = (event: CustomEvent) => {
    // event.detail is the JSON-RPC params = the backend body {action, payload}; a {notification} wrapper is accepted too
    const notification = event.detail?.notification ?? event.detail
    if (!notification) return
    switch (notification.action) {
      case 'participantsChanged': {
        const {changes, participants} = notification.payload ?? {}
        if (changes !== undefined && Array.isArray(changes.addedObservers) && Array.isArray(participants)) {
          const addedObservers = participants.filter(
            (participant: any) => participant && changes.addedObservers.includes(participant.partyId)
          )
          addedObservers.forEach((addedObserver: any) => {
            delete addedObserver.partyId
            // already in the list (join-time info or an earlier notification): keep that entry
            if (session.getParticipantInfo(addedObserver.id)) return
            session.createParticipant(addedObserver)
          })
        }
        break
      }
    }
  }
  onMounted(() => {
    jsonRpc.on('plt:notification', onNotification)
  })
  onUnmounted(() => {
    jsonRpc.off('plt:notification', onNotification)
  })
}
